import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import CurtainsClosedOutlinedIcon from "@mui/icons-material/CurtainsClosedOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import emailIcon from "../../../assets/img/emailIcon.svg";
import lucide_lock from "../../../assets/img/lucide_lock.svg";
import { useState } from "react";
import ReactCountryFlag from "react-country-flag";
import { useRef } from "react";
import { showToast } from "../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { useGlobalState } from "../../../Providers/GlobalStateProvider";
import { hitCreateProfileClientApi } from "../../../Redux/Client/CreateProfileSlice";
import { hitGetProfileClientApi } from "../../../Redux/Client/GetProfileClientSlice";
import { hitSignUpClientApi } from "../../../Redux/Client/SignUpClientSlice";
import {
  hitSendEmailVerificationV2,
  hitVerifyEmailVerificationV2,
} from "../../../Redux/Client/EmailVerificationV2Slice";
import logo from "../../../assets/img/SimpleRenovate.svg";
import activePricingIcon from "../../../assets/img/active pricing icon.svg";
import GoogleMapsPlacesProvider from "../../Common/GoogleMaps/GoogleMapsPlacesProvider";
import CityLocationSearch, {
  EMPTY_CITY_LOCATION,
  getResolvedCity,
  hasValidCoordinates,
} from "../../Common/CityLocationSearch/CityLocationSearch";
import {
  isStrongPassword,
  PASSWORD_COMPLEXITY_MESSAGE,
} from "../../../Helper/passwordValidation";
// import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
// import External from "../../../assets/svg/External";
// import { hitGetStartVerificationVeriff } from "../../../Redux/Common/CreateVeriffVerificationSlice";

const countries = [
  { code: "+1", country: "US", flag: "🇺🇸", name: "United States" },
  { code: "+1", country: "CA", flag: "🇨🇦", name: "Canada" },
  { code: "+44", country: "GB", flag: "🇬🇧", name: "United Kingdom" },
  { code: "+91", country: "IN", flag: "🇮🇳", name: "India" },
  { code: "+86", country: "CN", flag: "🇨🇳", name: "China" },
  { code: "+81", country: "JP", flag: "🇯🇵", name: "Japan" },
  { code: "+49", country: "DE", flag: "🇩🇪", name: "Germany" },
  { code: "+33", country: "FR", flag: "🇫🇷", name: "France" },
  { code: "+39", country: "IT", flag: "🇮🇹", name: "Italy" },
  { code: "+34", country: "ES", flag: "🇪🇸", name: "Spain" },
  { code: "+61", country: "AU", flag: "🇦🇺", name: "Australia" },
  { code: "+7", country: "RU", flag: "🇷🇺", name: "Russia" },
  { code: "+55", country: "BR", flag: "🇧🇷", name: "Brazil" },
  { code: "+52", country: "MX", flag: "🇲🇽", name: "Mexico" },
  { code: "+82", country: "KR", flag: "🇰🇷", name: "South Korea" },
  { code: "+31", country: "NL", flag: "🇳🇱", name: "Netherlands" },
  { code: "+46", country: "SE", flag: "🇸🇪", name: "Sweden" },
  { code: "+47", country: "NO", flag: "🇳🇴", name: "Norway" },
  { code: "+45", country: "DK", flag: "🇩🇰", name: "Denmark" },
  { code: "+358", country: "FI", flag: "🇫🇮", name: "Finland" },
  { code: "+48", country: "PL", flag: "🇵🇱", name: "Poland" },
  { code: "+41", country: "CH", flag: "🇨🇭", name: "Switzerland" },
  { code: "+43", country: "AT", flag: "🇦🇹", name: "Austria" },
  { code: "+32", country: "BE", flag: "🇧🇪", name: "Belgium" },
  { code: "+351", country: "PT", flag: "🇵🇹", name: "Portugal" },
  { code: "+30", country: "GR", flag: "🇬🇷", name: "Greece" },
  { code: "+420", country: "CZ", flag: "🇨🇿", name: "Czech Republic" },
  { code: "+36", country: "HU", flag: "🇭🇺", name: "Hungary" },
  { code: "+40", country: "RO", flag: "🇷🇴", name: "Romania" },
  { code: "+64", country: "NZ", flag: "🇳🇿", name: "New Zealand" },
  { code: "+65", country: "SG", flag: "🇸🇬", name: "Singapore" },
  { code: "+60", country: "MY", flag: "🇲🇾", name: "Malaysia" },
  { code: "+66", country: "TH", flag: "🇹🇭", name: "Thailand" },
  { code: "+63", country: "PH", flag: "🇵🇭", name: "Philippines" },
  { code: "+62", country: "ID", flag: "🇮🇩", name: "Indonesia" },
  { code: "+84", country: "VN", flag: "🇻🇳", name: "Vietnam" },
  { code: "+27", country: "ZA", flag: "🇿🇦", name: "South Africa" },
  { code: "+20", country: "EG", flag: "🇪🇬", name: "Egypt" },
  { code: "+234", country: "NG", flag: "🇳🇬", name: "Nigeria" },
  { code: "+254", country: "KE", flag: "🇰🇪", name: "Kenya" },
  { code: "+971", country: "AE", flag: "🇦🇪", name: "UAE" },
  { code: "+966", country: "SA", flag: "🇸🇦", name: "Saudi Arabia" },
  { code: "+972", country: "IL", flag: "🇮🇱", name: "Israel" },
  { code: "+90", country: "TR", flag: "🇹🇷", name: "Turkey" },
  { code: "+54", country: "AR", flag: "🇦🇷", name: "Argentina" },
  { code: "+56", country: "CL", flag: "🇨🇱", name: "Chile" },
  { code: "+57", country: "CO", flag: "🇨🇴", name: "Colombia" },
  { code: "+51", country: "PE", flag: "🇵🇪", name: "Peru" },
];

const SignUpStepOneClientInner = () => {
  const [selected, setSelected] = useState(countries[0]);
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  const filteredCountries = countries.filter(
    (country) =>
      country.name.toLowerCase().includes(search.toLowerCase()) ||
      country.code.includes(search) ||
      country.country.toLowerCase().includes(search.toLowerCase()),
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearch("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (country) => {
    setSelected(country);
    setCountryCode(country.code);
    setFormData((prev) => ({ ...prev, countryCode: country.code }));
    setIsOpen(false);
    setSearch("");
  };

  const navigation = useNavigate();
  const dispatch = useDispatch();
  const { setGlobalLoading } = useGlobalState();
  const [countryCode, setCountryCode] = useState("+1");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setGlobalLoading(loading);
    return () => setGlobalLoading(false);
  }, [loading, setGlobalLoading]);
  const [showPassword, setShowPassword] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);
  const [showPasswordField, setShowPasswordField] = useState(true);

  const [emailCodeSent, setEmailCodeSent] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [code, setCode] = useState(Array(6).fill(""));
  const [resendTimer, setResendTimer] = useState(0);
  const inputsRef = useRef([]);

  const isPhoneValid = (phone) => {
    if (!phone) return false;
    const sanitizedPhone = phone.trim();
    const isAllZeros = /^0+$/i.test(sanitizedPhone);
    const startsWithZero = sanitizedPhone.startsWith("0");
    const isLessThan10 = sanitizedPhone.length < 10;
    return !(isLessThan10 || startsWithZero || isAllZeros);
  };

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    // zipCode: "",
    // city: "",
    // state: "",
    // country: "United States",
    // latitude: "",
    // longitude: "",
    // address: "",
    mobileNumber: "",
    countryCode: "+1",
    profileSteps: 2,
  });
  const [locationData, setLocationData] = useState(EMPTY_CITY_LOCATION);

  const fetchClientProfile = async () => {
    setLoading(true);
    try {
      const response = await dispatch(hitGetProfileClientApi());
      const data = response.payload?.data;
      if (!data) return;

      setFormData((prev) => ({
        ...prev,
        firstName: data.firstName || "",
        lastName: data.lastName || "",
        email: data.email || "",
        // zipCode: data.zipCode || "",
        mobileNumber: data.mobileNumber || "",
        countryCode: data.countryCode || "+1",
        // address: data.address || "",
        // city: data.city || "",
        // state: data.state || "",
        // country: data.country || "",
        // latitude: data.latitude ?? "",
        // longitude: data.longitude ?? "",
      }));

      if (data.loginSignUpType !== 1) {
        setShowPasswordField(false);
      }
     

      const phoneCountryCode = data.countryCode || "+1";
      setCountryCode(phoneCountryCode);

      const matchedCountry = countries.find((c) => c.code === phoneCountryCode);
      if (matchedCountry) {
        setSelected(matchedCountry);
      }

      if (data.city || data.latitude || data.longitude) {
        setLocationData({
          address: data.address || [data.city, data.state, data.country].filter(Boolean).join(", "),
          city: data.city || "",
          state: data.state || "",
          country: data.country || "",
          zip: data.zipCode || "",
          latitude: data.latitude ?? "",
          longitude: data.longitude ?? "",
          placeId: data.placeId || "",
        });
      }

      if (Number(data.isEmailVerified) === 1) {
        setEmailVerified(true);
      }
    } catch (error) {
      console.error("Error fetching client profile:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const clientToken = localStorage.getItem("clientToken");
    if (clientToken) {
      fetchClientProfile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (resendTimer <= 0) return undefined;
    const timer = setTimeout(() => setResendTimer((prev) => prev - 1), 1000);
    return () => clearTimeout(timer);
  }, [resendTimer]);

  const handleCodeChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]?$/.test(value)) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);
      setVerificationCode(newCode.join(""));
      if (value && index < 5) {
        inputsRef.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const validateAllFields = () => {
    if (!formData.firstName.trim()) {
      return { valid: false, message: "Please enter your first name" };
    }
    if (!formData.lastName.trim()) {
      return { valid: false, message: "Please enter your last name" };
    }
    if (!formData.email.trim()) {
      return { valid: false, message: "Please enter your email" };
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email.trim())) {
      return { valid: false, message: "Please enter a valid email address" };
    }
    if (showPasswordField === true) {
      if (!isStrongPassword(formData.password)) {
        return { valid: false, message: PASSWORD_COMPLEXITY_MESSAGE };
      }
    }
    if (!formData.mobileNumber.trim()) {
      return { valid: false, message: "Please enter your phone number" };
    }
    if (!isPhoneValid(formData.mobileNumber)) {
      return { valid: false, message: "Please enter a valid phone number" };
    }
    if (!getResolvedCity(locationData) || !locationData.state?.trim()) {
      return {
        valid: false,
        message: "Please select your city from the search suggestions",
      };
    }
    if (!hasValidCoordinates(locationData)) {
      return {
        valid: false,
        message: "Please select your city from the search suggestions",
      };
    }
    if (!termsChecked) {
      return {
        valid: false,
        message: "You must agree to the Terms of Service and Privacy Policy",
      };
    }
    return { valid: true };
  };

  const getLocationPayload = () => ({
    city: getResolvedCity(locationData),
    state: locationData.state.trim(),
    country: locationData.country.trim(),
    latitude: locationData.latitude,
    longitude: locationData.longitude,
  });

  const buildSignUpPayload = () => ({
    firstName: formData.firstName.trim(),
    lastName: formData.lastName.trim(),
    email: formData.email.trim(),
    password: formData.password,
    mobileNumber: formData.mobileNumber,
    countryCode: formData.countryCode || countryCode,
    ...getLocationPayload(),
  });

  const submitSignUp = async () => {
    const validation = validateAllFields();
    if (!validation.valid) {
      showToast(validation.message, "error");
      return;
    }
    setLoading(true);
    try {
      const response = await dispatch(hitSignUpClientApi(buildSignUpPayload()));
      setLoading(false);
      console.log("response", response);
      if (response.payload?.status === true) {
        setCode(Array(6).fill(""));
        setVerificationCode("");
        showToast("Enter otp to complete your profile", "success");
        setEmailCodeSent(true);
        setResendTimer(30);
      } else {
        showToast(response.error?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      console.error("Sign up error:", error);
    }
  };

  const sendEmailVerificationCode = async () => {
    setLoading(true);
    try {
      const response = await dispatch(
        hitSendEmailVerificationV2({ email: formData.email.trim() }),
      );
      setLoading(false);
      if (response.payload?.status === true) {
        setCode(Array(6).fill(""));
        setVerificationCode("");
        showToast(response.payload.message || "Verification code sent", "success");
        setEmailCodeSent(true);
        setResendTimer(30);
      } else {
        showToast(response.payload?.message || "Failed to send code", "error");
      }
    } catch (error) {
      setLoading(false);
      console.error("Send email verification error:", error);
    }
  };

  const profileSubmittingRef = useRef(false);

  const logSignupStep = (step, detail) => {
    console.log(`[Client Signup] ${step}`, detail);
  };

  const getThunkErrorMessage = (result, fallback) => {
    if (hitCreateProfileClientApi.rejected.match(result)) {
      return result.payload?.message || result.error?.message || fallback;
    }
    return result.payload?.message || fallback;
  };

  const completeProfileSignup = async () => {
    if (profileSubmittingRef.current) {
      logSignupStep("Create profile skipped — request already in progress");
      return;
    }

    const validation = validateAllFields();
    if (!validation.valid) {
      showToast(validation.message, "error");
      return;
    }

    profileSubmittingRef.current = true;
    setLoading(true);

    const clientToken = localStorage.getItem("clientToken");
    logSignupStep("Step 0 — starting create profile", {
      email: formData.email.trim(),
      hasClientToken: Boolean(clientToken),
      profileStepsTarget: 2,
    });

    try {
      const step1Payload = {
        email: formData.email.trim(),
        password: formData.password,
        profileSteps: 1,
      };
      logSignupStep("Step 1 — request", step1Payload);

      const step1 = await dispatch(hitCreateProfileClientApi(step1Payload));
      logSignupStep("Step 1 — response", step1);

      if (hitCreateProfileClientApi.rejected.match(step1)) {
        showToast(getThunkErrorMessage(step1, "Step 1 failed"), "error");
        return;
      }
      if (step1.payload?.status !== true) {
        showToast(getThunkErrorMessage(step1, "Step 1 failed"), "error");
        return;
      }

      const profilePayload = {
        ...formData,
        email: formData.email.trim(),
        password: formData.password,
        profileSteps: 2,
        ...getLocationPayload(),
      };
      logSignupStep("Step 2 — request", profilePayload);

      const step2 = await dispatch(hitCreateProfileClientApi(profilePayload));
      logSignupStep("Step 2 — response", step2);

      if (hitCreateProfileClientApi.rejected.match(step2)) {
        showToast(getThunkErrorMessage(step2, "Failed to create profile"), "error");
        return;
      }
      if (step2.payload?.status !== true) {
        showToast(getThunkErrorMessage(step2, "Failed to create profile"), "error");
        return;
      }

      showToast("Profile created successfully", "success");
      localStorage.setItem("clientToken", step2.payload.data.accessToken);
      localStorage.setItem("clientId", step2.payload.data._id);
      localStorage.setItem("clientData", JSON.stringify(step2.payload.data));
      logSignupStep("Step 3 — success, navigating to dashboard", step2.payload.data);
      navigation("/client/dashboard");
    } catch (error) {
      logSignupStep("Create profile — unexpected error", error);
      showToast("Something went wrong while creating your profile", "error");
    } finally {
      profileSubmittingRef.current = false;
      setLoading(false);
    }
  };

  const verifyEmailCode = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!verificationCode || verificationCode.length < 6) {
      showToast("Please enter the 6-digit verification code", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await dispatch(
        hitVerifyEmailVerificationV2({
          email: formData.email.trim(),
          otp: verificationCode,
        }),
      );
      if (response.payload?.status === true) {
        console.log("[Client Signup] Email OTP verified", response.payload);
        localStorage.setItem("clientToken", response.payload.data.accessToken);
        localStorage.setItem("clientId", response.payload.data._id);
        localStorage.setItem("clientData", JSON.stringify(response.payload.data));
        showToast(response.payload.message || "Email verified successfully", "success");
        setEmailVerified(true);
        setEmailCodeSent(false);
        await completeProfileSignup();
      } else {
        setLoading(false);
        const message =
          response.payload?.message ||
          response.error?.message ||
          "Invalid verification code";
        showToast(message, "error");
      }
    } catch (error) {
      setLoading(false);
      console.error("Verify email error:", error);
    }
  };

  const resendEmailVerificationCode = async (e) => {
    e.preventDefault();
    if (resendTimer > 0) return;
    await sendEmailVerificationCode();
  };

  const isFormReady = validateAllFields().valid;
  const primaryButtonLabel = emailVerified ? "Create Account" : "Sign Up";
  const isPrimaryButtonEnabled =
    isFormReady && (emailVerified || !emailCodeSent);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePrimaryButton = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isFormReady) {
      const validation = validateAllFields();
      showToast(validation.message || "Please fill all required fields", "error");
      return;
    }

    if (emailVerified) {
      await completeProfileSignup();
      return;
    }

    if (emailCodeSent) {
      showToast("Please verify your email with the code sent to your inbox", "error");
      return;
    }

    await submitSignUp();
  };

  return (
    <div className="custom_container mb-5 client-signup-page">
      <div className="company-form">
        {/* Header */}
        {/* <div className="bussiness-form-header-top">
          <div className="business-form__header">
            <div className="business-form__step">
              <span className="business-form__step-badge">
                <DoneOutlinedIcon />
              </span>
              <div>
                <span className="title_head">Profile Details</span>
                <p className="business-form__step__number mb-0">Step 1 of 1</p>
              </div>
            </div>
            <p className="business-form__exit">1/1</p>
          </div>
          <div className="progress-bar-container">
            <div className="progress-bar-fill" style={{ width: "100%" }}></div>
          </div>
        </div> */}

        {/* Title */}
        <div className="company-form__title">
          <div className="company-form__logo">
            <img src={logo} alt="SimpleRenovate" />
          </div>
          <h2>Tell Us About Yourself</h2>
          <p>We’ll help you create a standout Client profile</p>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            handlePrimaryButton(e);
          }}
        >
          <div style={{ display: "flex", gap: 10 }}>
            <div>
              <label>
                First Name <span style={{ color: "#cc4645" }}>*</span>
              </label>
              <input
                type="text"
                placeholder="John"
                value={formData.firstName}
                onChange={(e) => {
                  const value = e.target.value;
                  const capitalized =
                    value.charAt(0).toUpperCase() + value.slice(1); // capitalize first letter
                  handleChange({
                    target: { name: "firstName", value: capitalized },
                  });
                }}
                name="firstName"
              />
            </div>

            <div>
              <label>
                Last Name <span style={{ color: "#cc4645" }}>*</span>
              </label>
              <input
                type="text"
                placeholder="Doe"
                value={formData.lastName}
                onChange={(e) => {
                  const value = e.target.value;
                  const capitalized =
                    value.charAt(0).toUpperCase() + value.slice(1); // capitalize first letter
                  handleChange({
                    target: { name: "lastName", value: capitalized },
                  });
                }}
                name="lastName"
              />
            </div>
          </div>

          <CityLocationSearch
            label="Location"
            value={locationData}
            onChange={setLocationData}
            disabled={emailVerified}
          />

          <label>
            Email Address <span style={{ color: "#cc4645" }}>*</span>
          </label>
          <div className="input-with-icon">
            <img src={emailIcon} alt="email" className="input-field-icon" />
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              disabled={emailVerified || showPasswordField === false || (emailCodeSent && !emailVerified)}
            />
          </div>
          {emailCodeSent && !emailVerified && (
            <div className="info-box" style={{ color: "#2c4390", marginBottom: 12 }}>
              We&apos;ve sent a verification code to <b>{formData.email}</b>
            </div>
          )}

          {(emailVerified || showPasswordField === false) && (
            <p className="send-code-btn-2">
              <img
                src={activePricingIcon}
                alt="check-icon"
                width={20}
                height={20}
                className="me-2"
              />
              Email Verified Sucessfully!
            </p>

          )}


          {showPasswordField === true &&
            <><label>
              Password <span style={{ color: "#cc4645" }}>*</span>
            </label><div className="input-with-icon input-with-icon--password password-input">
                <img src={lucide_lock} alt="lock" className="input-field-icon" />
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange} />
                <button
                  type="button"
                  className="input-toggle-icon"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? (
                    <VisibilityOutlinedIcon />
                  ) : (
                    <VisibilityOffOutlinedIcon />
                  )}
                </button>
              </div>
              {formData.password && !isStrongPassword(formData.password) && (
                <p
                  style={{
                    marginTop: 8,
                    marginBottom: 0,
                    fontSize: 13,
                    color: "#cc4645",
                  }}
                >
                  {PASSWORD_COMPLEXITY_MESSAGE}
                </p>
              )}
              </>
          }

          <label>
            Phone Number <span style={{ color: "#cc4645" }}>*</span>
          </label>
          <div style={{ display: "flex", gap: 10 }}>
            <div className="country-selector-container" ref={dropdownRef}>
              <button
                className="country-selector-trigger"
                onClick={() => setIsOpen(!isOpen)}
                type="button"
                style={{ display: "flex", alignItems: "center", gap: 6 }}
              >
                <ReactCountryFlag
                  countryCode={selected.country}
                  svg
                  style={{ width: "1.5em", height: "1.5em", marginRight: 4 }}
                />
                <span className="code-text">{selected.code}</span>
                <svg
                  className={`chevron ${isOpen ? "open" : ""}`}
                  viewBox="0 0 24 24"
                  fill="none"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>

              {isOpen && (
                <div className="dropdown">
                  <div className="search-container">
                    <input
                      type="text"
                      className="search-input"
                      placeholder="Search country..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      autoFocus
                    />
                  </div>

                  <div className="country-list">
                    {filteredCountries.length > 0 ? (
                      filteredCountries.map((country, index) => (
                        <div
                          key={`${country.country}-${index}`}
                          className={`country-item ${country.country === selected.country ? "selected" : ""}`}
                          onClick={() => handleSelect(country)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                        >
                          <ReactCountryFlag
                            countryCode={country.country}
                            svg
                            style={{
                              width: "1.5em",
                              height: "1.5em",
                              marginRight: 4,
                            }}
                          />
                          <div className="country-info">
                            <span className="country-name">{country.name}</span>
                            <span className="country-code">{country.code}</span>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="no-results">
                        <div className="no-results-emoji">🔍</div>
                        <div>No countries found</div>
                      </div>
                    )}
                  </div>
                </div>
              )}
              <input
                type="number"
                placeholder="Enter your phone number"
                value={formData.mobileNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, ""); // remove non-digits
                  if (value.length <= 10) {
                    setFormData((prev) => ({ ...prev, mobileNumber: value }));
                  }
                }}
                name="mobileNumber"
                maxLength={10}
                pattern="[0-9]"
                style={{ borderRadius: "0 8px 8px 0" }}
              />
            </div>
          </div>
          {/* <div className="verification-box">
            <div className="verification-box__icon">✔</div>
            <div className="verification-box__content">
              <p className="verification-title">Identity verification</p>
              <p className="verification-text">
                <span></span>
                Identity verification complete
              </p>
              <p className="verification-text">
                Your identity has been verified successfully and is active
                on your profile.
              </p>
            </div>
          </div> */}

          <div className="d-flex align-items-start gap-2 my-3">
            <input
              type="checkbox"
              id="client-signup-terms-checkbox"
              className="mb-0 mt-1"
              style={{ width: "auto" }}
              checked={termsChecked}
              onChange={(e) => setTermsChecked(e.target.checked)}
            />
            <label
              htmlFor="client-signup-terms-checkbox"
              className="text-sm cursor-pointer select-none mb-0"
              style={{ fontWeight: 400, textAlign: "left" }}
            >
              I agree to the{" "}
              <a
                href="/terms-of-services"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#cc4645", fontWeight: 600 }}
              >
                Terms of Service
              </a>{" "}
              and{" "}
              <a
                href="/privacy-policies"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#cc4645", fontWeight: 600 }}
              >
                Privacy Policy
              </a>
              .
            </label>
          </div>

          {emailCodeSent && !emailVerified && (
            <>
              <h5 className="my-3" style={{ fontWeight: 700 }}>
                Enter Verification Code
              </h5>
              <div className="code-inputs mb-2 code-inputs-otp">
                {code.map((digit, idx) => (
                  <input
                    key={idx}
                    type="text"
                    maxLength="1"
                    value={digit}
                    ref={(el) => (inputsRef.current[idx] = el)}
                    onChange={(e) => handleCodeChange(e, idx)}
                    onKeyDown={(e) => handleKeyDown(e, idx)}
                  />
                ))}
              </div>
              <button
                type="button"
                className="verify-btn mb-2"
                onClick={verifyEmailCode}
                disabled={verificationCode.length < 6}
                style={{
                  width: "100%",
                  background: verificationCode.length >= 6 ? "#b22222" : "#b3b3b3",
                  cursor: verificationCode.length >= 6 ? "pointer" : "not-allowed",
                }}
              >
                Verify Email
              </button>
              <p className="login-text mb-3">
                Didn&apos;t receive code?{" "}
                <button
                  type="button"
                  className="resend-btn"
                  onClick={resendEmailVerificationCode}
                  disabled={resendTimer > 0}
                  style={{
                    background: "none",
                    border: "none",
                    color: resendTimer > 0 ? "#aaa" : "#b22222",
                    textDecoration: "underline",
                    cursor: resendTimer > 0 ? "not-allowed" : "pointer",
                    padding: 0,
                    font: "inherit",
                    fontWeight: 500,
                  }}
                >
                  Resend Code{resendTimer > 0 ? ` (${resendTimer}s)` : ""}
                </button>
              </p>
            </>
          )}



          <button
            type="submit"
            className={`next-btn${isPrimaryButtonEnabled ? " next-btn--enabled" : ""}`}
            disabled={!isPrimaryButtonEnabled || loading}
          >
            {primaryButtonLabel}
          </button>

          <p className="register-text">
            Already have an account?{" "}
            <a href="/client/login">Login here</a>
          </p>
        </form>
      </div>
    </div>
  );
};

const SignUpStepOneClient = () => (
  <GoogleMapsPlacesProvider>
    <SignUpStepOneClientInner />
  </GoogleMapsPlacesProvider>
);

export default SignUpStepOneClient;
